__turbopack_context__.v({
  "className": "figtree_b16baf8f-module__T_TJVq__className",
});
